// import mediasMixins from 'root/mixins/mediasMixin.js';
import utilsMixin from 'root/mixins/utilsMixin.js'

export default {
  name: 'deprati-installment',
  mixins: [
    // mediasMixins,
    utilsMixin
  ],

  props: [
    'rawinstallments'
  ],

  data () {
    return {
    }
  },

  methods: {
  },

  computed: {
    installments: function () {
      return _.get(this.$root.pdpProduct, 'installments', null) || this.isJson(this.rawinstallments)
    }
  },

  mounted: function () {
  }

}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/product/depratiinstallment/depratiinstallment.js